import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=c2c28d1c&scoped=true"
import script from "./CookieConsent.vue?vue&type=script&lang=ts"
export * from "./CookieConsent.vue?vue&type=script&lang=ts"
import style0 from "./CookieConsent.vue?vue&type=style&index=0&id=c2c28d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c28d1c",
  null
  
)

export default component.exports